import { useQuery } from "@tanstack/react-query"
import { paths } from "../apiTypes"

export type VaultListRequestBody = NonNullable<
  paths["/v2/vault/list"]["post"]["requestBody"]
>["content"]["application/json"]
export type VaultListResponse =
  paths["/v2/vault/list"]["post"]["responses"]["200"]["content"]["application/json"]

function getApiBase() {
  // Prefer env var if present, fallback to localhost pattern given by spec
  return process.env.NEXT_PUBLIC_EULER_API_URL ?? "http://localhost:42069"
}

export function useVaultListIndexer(
  body: VaultListRequestBody,
  {
    enabled = true,
    select,
  }: {
    enabled?: boolean
    select?: (data: VaultListResponse) => unknown
  } = {},
) {
  // Always add chainId as a query param
  const chainIdStr = body.chainId.toString()
  // passing the chainId is needed for the proxy to route properly
  const url = `${getApiBase()}/v2/vault/list?chainId=${encodeURIComponent(
    chainIdStr,
  )}`

  return useQuery<VaultListResponse, Error, VaultListResponse>({
    queryKey: ["vaultListIndexer", body],
    queryFn: async () => {
      // There are issues with the chainId being send as number so we need to convert it to string
      const bodyString = JSON.stringify(body)
      console.log("bodyString", bodyString)
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: bodyString,
      })
      if (!response.ok) {
        throw new Error(
          `Failed to fetch vault list, status: ${response.status}`,
        )
      }
      return response.json()
    },
    // Narrow to consumer shape if select provided
    select: (data) => (select ? (select(data) as VaultListResponse) : data),
    enabled: enabled && !!body?.chainId,
    refetchOnWindowFocus: false,
  })
}
